import { FC } from 'react';

import { Popup } from '@components/layout/Popup/Popup';

import { ReceivedBadgesContent } from './ReceivedBadgesContent';

export const ReceivedBadgesPopup: FC<{
  isVisible: boolean;
  onClose: () => void;
}> = ({ isVisible, onClose }) => {
  return (
    <Popup isVisible={isVisible} onClose={onClose}>
      <Popup.Content>
        {isVisible && (
          <div className="mt-2">
            <ReceivedBadgesContent />
          </div>
        )}
      </Popup.Content>
    </Popup>
  );
};
